import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { BookingFlowStep, PootsyButton } from "../DesignFunctions"
import { GeosuggestInput } from "../InputsFunctions"

import pinUser from '../../static/img/pin-user.png'
import * as actions from "../../actions/acBookingFlow"

import benefit1 from '../../static/img/booking-flow-benefit1.png'
import benefit2 from '../../static/img/booking-flow-benefit2.png'
import benefit3 from '../../static/img/booking-flow-benefit3.png'

import ZipCodeNotCoveredModal from './ZipCodeNotCoveredModal'

class BookingFlowAddressSelection extends Component {

	render() {
		let { t } = this.context

		let headerContent = {
			picto: pinUser,
			title: t('booking_flow_first_step_header'),
			subtitle: t('booking_flow_first_step_input_prompt')
		}

		return (
			<BookingFlowStep customClass="step-one" headerContent={headerContent}>
				{this.props.metadata.enterZipCodeNotCovered && <ZipCodeNotCoveredModal />}
				<GeosuggestInput
					geoSuggestProps={{
						placeholder: t('address_input_placeholder'),
						country: "be",
						onSuggestSelect: this.onSuggestionSelected
					}}
				/>
				<PootsyButton 
					text={t('next_step')} 
					onClick={this.onNextButtonClick}
					disabled={!this.props.metadata.isStepWelcomeValid}
				/>
				<div className="bottom">
					{this.renderPootsyBenefit(t('pootsy_benefit_one'), benefit2 )}
					{this.renderPootsyBenefit(t('pootsy_benefit_two'), benefit3)}
					{this.renderPootsyBenefit(t('pootsy_benefit_three'), benefit1)}
				</div>
			</BookingFlowStep>
		)
	}

	renderPootsyBenefit = (text, imageSrc) => {
		return (
			<div className="cell">
				<div className="round">
					<img src={imageSrc} alt=""/>
				</div>
				<div className="text">
					{text}
				</div>
			</div>
		)
	}

	onSuggestionSelected = (suggestion) => {
		this.props.dispatch(actions.addressSuggestionSelected(suggestion))
	}

	onNextButtonClick = () => {
		this.props.dispatch(actions.bookingFlowValidateStepWelcome())
	}
}

BookingFlowAddressSelection.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	metadata: state.metadataReducer.bookingFlow
})
export default connect(mapStateToProps)(BookingFlowAddressSelection);


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowAddressSelection.js